import { localStore } from './platform'

// Reactions chosen on this device, most recent first: the emoji picker shows them before everything else.
const STORAGE_KEY = 'boss-chat.recent-reactions.v1'
export const MAX_RECENT_REACTIONS = 16

export function loadRecentReactions(storage: Pick<Storage, 'getItem'> | undefined = localStore()): string[] {
  try {
    const parsed: unknown = JSON.parse(storage?.getItem(STORAGE_KEY) ?? '[]')
    return Array.isArray(parsed) ? parsed.filter((e): e is string => typeof e === 'string').slice(0, MAX_RECENT_REACTIONS) : []
  } catch {
    return []
  }
}

export function rememberReaction(emoji: string, storage: Pick<Storage, 'getItem' | 'setItem'> | undefined = localStore()): void {
  try {
    const next = [emoji, ...loadRecentReactions(storage).filter((e) => e !== emoji)].slice(0, MAX_RECENT_REACTIONS)
    storage?.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch {
    // Storage can be unavailable (private mode, quota): recent reactions are a convenience.
  }
}
